import React, { createContext } from "react"

export const PreviewContext = createContext({ isPreview: false })

export const PreviewProvider = ({ children, isPreview }) => (
  <PreviewContext.Provider value={{ isPreview }}>
    {children}
  </PreviewContext.Provider>
)
